import tw from "twin.macro";

export const TH = tw.th`px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider`;

export const TD = tw.td`px-2 py-1 whitespace-nowrap text-sm border-b border-gray-200`;
